import { Immutable } from "immer";
import React from "react";

import { IMenuPromo } from "../../utils/menu.interface";

type IProps = Immutable<{
    promoArrayEl: IMenuPromo;
}>;

export const PromoAd = ({ promoArrayEl }: IProps): React.ReactNode => {
    let link;
    let imageContent: React.JSX.Element | null = null;
    let customHTMLContent: React.JSX.Element | null = null;

    if (promoArrayEl.value.page || promoArrayEl.value.external_link) {
        link = promoArrayEl.value.page
            ? promoArrayEl.value.page.url
            : promoArrayEl.value.external_link;
    }

    if (promoArrayEl.value.image !== null) {
        if (promoArrayEl.value.image.url) {
            imageContent = (
                <div className="main-dropdown-menu-ad__image-container">
                    <img
                        src={promoArrayEl.value.image.url}
                        alt={promoArrayEl.value.image.title}
                    />
                </div>
            );
        }
    }

    if (promoArrayEl.value.html) {
        customHTMLContent = (
            <div
                className="main-dropdown-menu-ad__content"
                dangerouslySetInnerHTML={{
                    __html: promoArrayEl.value.html,
                }}
            ></div>
        );
    }

    if (link) {
        // Need link title since content is an image. See #13290
        return (
            <a href={link} className="main-dropdown-menu-ad">
                {imageContent}
                {customHTMLContent}
            </a>
        );
    }

    return (
        <div className="main-dropdown-menu-ad">
            {imageContent}
            {customHTMLContent}
        </div>
    );
};
